<template>
  <div id="EvaluateurDevis">

  <div class="entryPointSunEthic" v-show="!estimationDone">


    <div class="sectionContainer">
      <div class="rowBootstrapp">
              <img src="/wp-content/uploads/2023/09/Picto_Habitation.svg" alt="" class="pictoSection">
              <span class="h2like sectionTitle">Votre habitation</span>
              <div class="col-12 col-lg-6 champ"  v-click-outside="hideAddress">
                <span class="h3like ">Votre adresse</span>
                <div class="inputZone">
                    <textarea class="" @focus="addressesShow = true;" @input="searchAddresses" style="width:100%;border:1px solid #008A83;padding:10px;resize:none;background:#FFF;" rows="1" resize="false" name="" v-model="address">

                    </textarea>
                    <ul v-if="addressesShow" class="address-list" >
        <li v-for="address in addresses" :key="address.id" @click="selectAddress(address)" class="address-item">
          {{ address.label }}
        </li>
      </ul>

                </div>
              </div>
        <div class="col-12 col-lg-6 champ">
          <span class="h3like">Type de compteur</span>
          <div class="inputZone">
            <div class="select">
              <select v-model="typeCompteur" class="" @change="coffrets_protection = null">
                <option value="mono">Monophasé</option>
                <option value="tri">Triphasé</option>
              </select>
            </div>

          </div>
        </div>
        <!-- <div class="col-12 col-lg-6 champ">
          <span class="h3like">Chauffage electrique</span>
          <div class="inputZone">
            <div class="select">
              <select v-model="chauffageElect" class="">
                <option value=true>Oui</option>
                <option value=false>Non</option>
              </select>
            </div>

          </div>
        </div> -->
      </div>

      <div class="rowBootstrapp">
        <div class="col-12 col-lg-6 champ" >
        <span class=" h3like">Orientation des panneaux </span>
        <div class="inputZone">
          <div class="select">
            <select v-model="orientation_panneaux" class="">
                <option value="NORD">Nord</option>
                <option value="NORD-EST">Nord-est</option>
                <option value="EST">Est</option>
                <option value="SUD-EST">Sud-est</option>
                <option value="SUD">Sud</option>
                <option value="SUD-OUEST">Sud-ouest</option>
                <option value="OUEST">Ouest</option>
                <option value="NORD-OUEST">Nord-ouest</option>
            </select>
          </div>

        </div>
    </div>

    <div class="col-12 col-lg-6 champ" >
    <span class=" h3like">Inclinaison des panneaux</span>
    <div class="inputZone">
      <div class="select">
        <select v-model="inclinaison_panneaux" class="">
            <option value="plat">À plat</option>
            <option value="faible">Faible (5 à 14°)</option>
            <option value="moyenne">Moyenne (15 à 24°)</option>
            <option value="standard">Standard (25 à 34°)</option>
            <option value="forte">Forte (35 à 44°)</option>
            <option value="facade">Sur façade (90°)</option>
        </select>
      </div>

    </div>
</div>

      </div>
      <div class="rowBootstrapp">
          <div class="col-12 champ">
            <span class="h3like">Montant mensuel de facture</span>
            <div class="wrapper-range">
              <div class="field">
                <div class="sliderValue">
                  <span><input type="number"  step="5" min="20" max="350"  v-model="monthlyBill" class="hideInput"> €</span>
                </div>
                <div class="value left">20€</div>
                <input type="range" min="20" max="350"  v-model='monthlyBill' step="5">
                <div class="value right">350€</div>
              </div>
            </div>
          </div>

        </div>

    </div>



  <span class="h2like sectionTitle text-center">Données du devis</span>
    <div class="sectionContainer">


      <div class="rowBootstrapp">
        <img src="/wp-content/uploads/2023/09/Picto_Panneaux.svg" alt="" class="pictoSection">
                <span class="h2like sectionTitle">Panneaux </span>

              <div class="col-12 col-lg-6 champ" >
      <span class=" h3like">Nombre de panneaux </span>
      <div class="wrapper-range">
        <div class="field">
          <div class="sliderValue">
            <span><input  step="1" min="2" max="30"  type="number" v-model="nb_panneaux" class="hideInput"></span>
          </div>
          <div class="value left">2</div>
          <input type="range" min="2" max="30" v-model='nb_panneaux'  step="1">
          <div class="value right">30</div>
        </div>
      </div>
    </div>

          <div class="col-12 col-lg-6 champ" >
      <span class="h3like ">Puissance du panneau</span>
      <div class="wrapper-range">
        <div class="field">
          <div class="sliderValue">
            <span><input type="number" v-model="puissance_panneau"  step="5" min="300" max="550" class="hideInput">W</span>
          </div>
          <div class="value left">300W</div>
          <input type="range" min="300" max="550" v-model='puissance_panneau' step="5">
          <div class="value right">550W</div>
        </div>
      </div>
    </div>
      </div>
    <div class="rowBootstrapp">
      <div class="col-12 col-lg-6 champ">
        <span class="h3like">Marque du panneau</span>
        <div class="inputZone">
          <div class="select">
            <select v-model="marque_panneaux" class="">
                <option v-for="(p,i) in listMarquePanneaux " :key="i" :value="p">{{p}}</option>
            </select>
          </div>

        </div>
      </div>
      <div class="col-12 col-lg-6 champ" v-if="marque_panneaux">
        <span class="h3like">Modèle de panneaux</span>
        <div class="inputZone">
          <div class="select">
            <select v-model="modelePanneau" class="">
              <option v-for="(p,i) in filteredPanneauxList" :key="i" :value="p.modele">{{p.modele}}</option>
            </select>
          </div>

        </div>
      </div>
    </div>
  </div>


  <div class="sectionContainer">
    <div class="rowBootstrapp">
      <img src="/wp-content/uploads/2023/09/Picto_onduleurs.svg" alt="" class="pictoSection">
              <span class="h2like sectionTitle">Onduleurs </span>

              <div class="col-12 champ">
                      <span class="h3like ">Type d'onduleurs </span>
                <div class="inclinaison_wrapper">
                  <p class="form__answer">
                    <input type="radio" name="typeOnduleur" id="onduleur" value="onduleur" v-model="typeOnduleur" @change="this.marque_onduleur = null; this.modele_onduleur = null;">
                    <label for="onduleur">
                      <span style="display:block" class="text_black">Onduleur</span>
                    </label>
                  </p>
                  <p class="form__answer">
                    <input type="radio" name="typeOnduleur" id="micro" value="micro" v-model="typeOnduleur" @change="this.marque_onduleur = null; this.modele_onduleur = null;">
                    <label for="micro">
                      <span style="display:block" class="text_black">Micro-Onduleur</span>
                    </label>
                  </p>
                </div>
              </div>
              <div class="col-12 col-lg-6 champ" >
      <span class=" h3like">Nombre <span v-if="typeOnduleur == 'onduleur'">d'onduleurs</span><span v-if="typeOnduleur == 'micro'">de micro-onduleurs</span></span>
      <div class="wrapper-range">
        <div class="field">
          <div class="sliderValue">
            <span><input  step="1" min="1" max="30"  type="number" v-model="nb_onduleur" class="hideInput"></span>
          </div>
          <div class="value left">1</div>
          <input type="range" min="1" max="30" v-model='nb_onduleur'  step="1">
          <div class="value right">30</div>
        </div>
      </div>
    </div>
              <div class="rowBootstrapp">


              <div class="col-12 col-lg-6 champ">
                <span class="h3like ">Marque</span>
                <div class="inputZone">
                  <div class="select">
                    <select class="" name="" t v-model="marque_onduleur">
                      <option v-for="(p,i) in listMarqueOnduleurs" :key="i" :value="p">{{p}}</option>
                    </select>
                  </div>

                </div>
              </div>
              <div class="col-12 col-lg-6 champ" v-if="marque_onduleur">
                <span class="h3like ">Modèle</span>
                <div class="inputZone">
                  <div class="select">
                    <select v-model="modele_onduleur"  class="" name="">
                      <option v-for="(p,i) in filteredOnduleursList" :key="i" :value="p.modele">{{p.modele}}</option>
                    </select>
                  </div>

                </div>
              </div>
            </div>

</div></div>


  <div class="sectionContainer">

    <div class="rowBootstrapp">
      <img src="/wp-content/uploads/2023/09/Picto_SystemeFixation.svg" alt="" class="pictoSection">
            <span class="h2like sectionTitle">Système de fixation </span>
      <div class="col-12 col-lg-4 champ">
        <span class=" h3like">Lieu de pose des panneaux</span>
        <div class="inputZone">
          <div class="select">
            <select v-model="lieuPose" class="">
              <option value="toit_plat">Toit plat</option>
              <option value="toit_incline">Toit incliné</option>
              <option value="sol">Au sol</option>
            </select>
          </div>

        </div>
      </div>
      <div class="col-12 col-lg-4 champ" v-if="lieuPose == 'toit_incline'">
        <span class="h3like ">Type de toiture</span>
        <div class="inputZone">
          <div class="select">
            <select v-model="typeToit" class="">
              <option value="tuiles">Tuile classique</option>
              <option value="ardoise">Ardoise</option>
              <option value="bacacier">Bac acier</option>
              <option value="fibrociment_toleondulee">Fibrociment / Tôle ondulée</option>
            </select>
          </div>

        </div>
      </div>

      <div class="col-12 col-lg-4 champ" v-if="lieuPose == 'toit_incline' || lieuPose == 'toit_plat'">
        <span class="h3like ">Nombre d'étage</span>
        <div class="inputZone">
          <div class="select">
            <select v-model="nb_etages" class="">
              <option value="0">Rez-de-chaussée</option>
              <option value="1">1 étage</option>
              <option value="2">2 étages</option>
              <option value="3">3 étages et plus</option>
            </select>
          </div>

        </div>
      </div>
    </div>

  </div>







<div class="sectionContainer">

  <div class="rowBootstrapp">
    <img src="/wp-content/uploads/2023/09/Picto_PasserelleSuivi.svg" alt="" class="pictoSection">
      <span class="h2like sectionTitle">Passerelle de suivi de production</span>

    <div class="col-12 champ">
            <span class="h3like ">Box ou passerelle de suivi de production</span>
      <div class="inclinaison_wrapper">
        <p class="form__answer">
          <input type="radio" name="gestionnaireEnergie" id="gestionnaireEnergie" :value='true' v-model="gestionnaireEnergie" >
          <label for="gestionnaireEnergie">
            <span style="display:block" class="text_black">Oui</span>
          </label>
        </p>
        <p class="form__answer">
          <input type="radio" name="gestionnaireEnergie" id="no_gestionnaireEnergie" :value='false' v-model="gestionnaireEnergie" >
          <label for="no_gestionnaireEnergie">
            <span style="display:block" class="text_black">Non</span>
          </label>
        </p>
      </div>
    </div>
    <div class="col-12 col-lg-6 champ" v-show="gestionnaireEnergie == true">
      <span class="h3like ">Marque</span>
      <div class="inputZone">
        <div class="select">
            <select v-model="marqueGestionnaire" class="">
        <option v-for="(p,i) in listMarqueGestionnaire" :key="i" :value="p">{{p}}</option>
      </select>
        </div>

      </div>
    </div>
    <div class="col-12 col-lg-6 champ" v-show="marqueGestionnaire && gestionnaireEnergie == true">
      <span class="h3like ">Modèle</span>
      <div class="inputZone">
        <div class="select">
          <select v-model="modeleGestionnaire" class="">
            <option v-for="(p,i) in filteredGestionnairesList" :key="i" :value="p.modele">{{p.modele}}</option>
          </select>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="sectionContainer">

  <div class="rowBootstrapp">
    <img src="/wp-content/uploads/2023/09/Picto_CoffretProtection.svg" alt="" class="pictoSection">
      <span class="h2like sectionTitle">Coffret de protection</span>
    <div class="col-12 champ">
            <span class="h3like ">Coffret de protection</span>
      <div class="inclinaison_wrapper">
        <p class="form__answer">
          <input type="radio" name="coffret" id="coffret" :value=true v-model="coffret">
          <label for="coffret">
            <span style="display:block" class="text_black">Oui</span>
          </label>
        </p>
        <p class="form__answer">
          <input type="radio" name="coffret" id="no_coffret" :value=false v-model="coffret">
          <label for="no_coffret">
            <span style="display:block" class="text_black">Non</span>
          </label>
        </p>
      </div>
    </div>
    <div class="col-12 col-lg-6 champ" v-if="coffret == true">
      <span class="h3like ">Modèle</span>
      <div class="inputZone">
        <div class="select">
          <select v-model="coffrets_protection" class="">
            <option v-for="(p,i) in filteredCoffretsList" :key="i" :value="p.modele">{{p.modele}}</option>
          </select>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="sectionContainer">

  <div class="rowBootstrapp">
    <img src="/wp-content/uploads/2023/09/Picto_BatterieStockage.svg" alt="" class="pictoSection">
      <span class="h2like sectionTitle">Batterie de stockage</span>

    <div class="col-12 champ">
            <span class="h3like ">Batterie de stockage</span>
      <div class="inclinaison_wrapper">
        <p class="form__answer">
          <input type="radio" name="Batterie" id="Batterie" :value=true v-model="Batterie">
          <label for="Batterie">
            <span style="display:block" class="text_black">Oui</span>
          </label>
        </p>
        <p class="form__answer">
          <input type="radio" name="Batterie" id="no_Batterie" :value=false v-model="Batterie">
          <label for="no_Batterie">
            <span style="display:block" class="text_black">Non</span>
          </label>
        </p>
      </div>
    </div>
    <div class="col-12 col-lg-6 champ" v-show="Batterie == true">
      <span class="h3like ">Capacité de la batterie</span>
      <div class="inputZone">
        <div class="select">
          <select v-model="capaciteBatterie" class="">
            <option v-for="(p,i) in listBatteries" :key="i" :value="p.capacite">{{p.capacite}}</option>
          </select>
        </div>

      </div>
    </div>

  </div>
</div>


<div class="sectionContainer">

  <div class="rowBootstrapp">
    <img src="/wp-content/uploads/2023/09/Picto_InfosSupplementaires.svg" alt="" class="pictoSection">
      <span class="h2like sectionTitle">Informations supplémentaires</span>

    <div class="col-12 champ">
            <span class="h3like ">Installateur agréé QUALI PV RGE ?</span>
      <div class="inclinaison_wrapper">
        <p class="form__answer">
          <input type="radio" name="qualipvrge" id="qualipvrge" :value=true v-model="qualipvrge">
          <label for="qualipvrge">
            <span style="display:block" class="text_black">Oui</span>
          </label>
        </p>
        <p class="form__answer">
          <input type="radio" name="qualipvrge" id="no_qualipvrge" :value=false v-model="qualipvrge">
          <label for="no_qualipvrge">
            <span style="display:block" class="text_black">Non</span>
          </label>
        </p>
      </div>
    </div>
    <div class="col-12 champ">
            <span class="h3like ">Démarches administratives (Autorisation Mairie, Enedis, Consuel) incluses dans le prix du devis ?</span>
      <div class="inclinaison_wrapper">
        <p class="form__answer">
          <input type="radio" name="demarche_administrative" id="demarche_administrative" :value=true v-model="demarche_administrative">
          <label for="demarche_administrative">
            <span style="display:block" class="text_black">Oui</span>
          </label>
        </p>
        <p class="form__answer">
          <input type="radio" name="demarche_administrative" id="no_demarche_administrative" :value=false v-model="demarche_administrative">
          <label for="no_demarche_administrative">
            <span style="display:block" class="text_black">Non</span>
          </label>
        </p>
      </div>
    </div>
    <div class="col-12 champ">
            <span class="h3like ">Prix du Consuel inclus dans le devis ?</span>
      <div class="inclinaison_wrapper">
        <p class="form__answer">
          <input type="radio" name="consuel" id="consuel" :value=true v-model="consuel">
          <label for="consuel">
            <span style="display:block" class="text_black">Oui</span>
          </label>
        </p>
        <p class="form__answer">
          <input type="radio" name="consuel" id="no_consuel" :value=false v-model="consuel">
          <label for="no_consuel">
            <span style="display:block" class="text_black">Non</span>
          </label>
        </p>
      </div>
    </div>


  </div>
</div>



<div class="sectionContainer">

  <div class="rowBootstrapp">
    <img src="/wp-content/uploads/2023/09/Picto_MontantDevis.svg" alt="" class="pictoSection">
      <span class="h2like sectionTitle">Montant du devis</span>
    <div class="col-12 col-md-12 champ">
      <span class=" h3like">Prix total TTC hors aides</span>
      <div class="inputZone">
        <div class="wrapper-range">
          <div class="field">
            <div class="sliderValue">
              <span><input type="number" v-model="total_ttc" class="hideInput"> €</span>
            </div>
            <div class="value left">3000 €</div>
            <input type="range" min="3000" max="30000" v-model='total_ttc' step="1">
            <div class="value right">30000 €</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 champ">
            <span class="h3like ">Taux de TVA appliqué sur le devis</span>
      <div class="inclinaison_wrapper">
        <div class="form__answer">
          <input type="radio" name="tva" id="tva10" value='10' v-model="tva">
          <label for="tva10">
            <span style="display:block" class="text_black">10%</span>
          </label>
        </div>
        <div class="form__answer">
          <input type="radio" name="tva" id="tva20" value='20' v-model="tva">
          <label for="tva20">
            <span style="display:block" class="text_black">20%</span>
          </label>
        </div>
      </div>

    </div>


  </div>
</div>
<div class="sectionContainer">

  <div class="rowBootstrapp">
    <span class="h2like sectionTitle">Vos informations</span>

      <div class="col-12 col-lg-4 champ">
        <span class="h3like ">Votre prénom</span>
        <div class="inputZone">
            <input type="text" v-model="user_prenom" style="width:100%;border:1px solid #008A83;padding:10px;resize:none;background:#FFF;"/>

        </div>
      </div>
          <div class="col-12 col-lg-4  champ">
      <span class="h3like ">Votre nom</span>
      <div class="inputZone">
          <input type="text" v-model="user_nom" style="width:100%;border:1px solid #008A83;padding:10px;resize:none;background:#FFF;"/>

      </div>
    </div>


    <div class="col-12 col-lg-4  champ">
      <span class="h3like ">Votre email</span>
      <div class="inputZone">
          <input type="email" v-model="user_email" style="width:100%;border:1px solid #008A83;padding:10px;resize:none;background:#FFF;"/>

      </div>
    </div>

    <div class="col-12 col-lg-4  champ">
      <span class="h3like ">Votre téléphone</span>
      <div class="inputZone">
          <input type="text" v-model="user_telephone" style="width:100%;border:1px solid #008A83;padding:10px;resize:none;background:#FFF;"/>

      </div>
    </div>
    <div class="col-12 champ">
      <label for="commercial_exploitation">
        <input type="checkbox" id="commercial_exploitation" value="true" name="commercial_exploitation" v-model="commercial_exploitation" @click="commercial_exploitation = !commercial_exploitation" />
        En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées par la société Sunethic.</label>
    </div>

</div>

</div>
<button id="doEvaluation" class="btn btn-simulateur" style="  border-radius: 30px !important;"  type="button" @click="runEval" name="button"> J'évalue mon devis</button>

<div class="alert alert-danger" v-if="errors.length > 0">
  <span class="col-12" v-for="(err,e) in errors" :key="e">{{err}}<br/></span>
</div>

  </div>

  <div class="calculatedValues" v-if='estimationDone == true'>
    <div class="recommandations">
      <div class="leftContainer">
        <h2>NOTRE ÉVALUATION</h2>
        <p class="text-justify recoDesc">
          Grâce aux données transmises, nous avons pu évaluer le prix et la qualité de votre devis de {{total_ttc}}€ hors aides, par rapport aux conditions actuelles du marché.<br/>
D'après nos estimations, un prix correct pour ce type d'installation serait d'environ <strong>{{Math.round(estimation.bon_prix)}}€ TTC</strong> hors aides
        </p>
      </div>
      <div class="rightContainer text-center">
        <span :class="'avisPastille '+estimation.code_note">{{estimation.note}}</span>
      </div>
    </div>
    <div class="resultDataContainer">
      <div class="resultProductDatas">
        <h3>Avis sur votre devis</h3>
        <div class="dataInner">
          <div class="dataItem ">
            Estimation du prix d'achat du matériel par un pro en HT
            <div class="tooltip">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Estimation sunethic selon les prix moyens du marché, tous intervenants confondus</span>
            </div>
            <br/>
            <strong>{{Math.round(estimation.prix_achat_materiel)}} €</strong>
          </div>
          <div class="dataItem ">
            Estimation du coût de main d'oeuvre en HT
            <div class="tooltip">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Estimation sunethic selon les prix moyens du marché, tous intervenants confondus</span>
            </div>
              <br/><strong>{{Math.round(estimation.main_oeuvre)}} €</strong>
          </div>
          <div class="dataItem ">
            Pays de fabrication des panneaux
              <br/><strong>{{estimation.pays_panneaux}}</strong>
          </div>
          <div class="dataItem ">
            Notre avis sur la marque des panneaux

            <br/>  <strong>{{estimation.gamme_panneaux}}</strong>

          </div>
          <div class="dataItem ">
            Taux de TVA à appliquer
              <br/><strong :class="(estimation.tva != tva) ? 'redText' : 'normalText'">{{estimation.tva}} %
                <span class="notice" v-if="estimation.tva != tva">Si la puissance de l'installation est inférieure à 3kWc alors le taux de TVA doit être de 10%, sinon il est de 20%.</span>
              </strong>
          </div>
          <div class="dataItem ">
            Estimation de la marge brute du devis par l'installateur en HT
            <div class="tooltip">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Estimation sunethic selon les prix moyens du marché, tous intervenants confondus ; Marge brute dégagée pour salariés autres que l'équipe de pose, frais fixes, bénéfices et impôts</span>
            </div>
              <br/><strong>{{Math.round(estimation.marge_brute)}} €</strong>
          </div>

          <div class="dataItem dataImportant">
            Estimation d'un bon prix correct pour ce matériel et votre maison (TTC)
            <div class="tooltip">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Estimation sunethic selon les prix moyens du marché, tous intervenants confondus</span>
            </div>
              <br/><strong>{{Math.round(estimation.bon_prix)}} €</strong>
          </div>
          <div class="dataItem dataImportant">
            Notre avis sur votre devis
              <br/><strong>{{ estimation.note}} - {{estimation.conseil}}</strong>
          </div>

          <div class="dataItem ">
            Recommandation de puissance Sunethic<div class="tooltip">
              <i class="fa fa-question"></i>
              <span class="tooltiptext">Estimation sunethic pour un objectif de 50% d'autoconsommation en tenant compte de votre adresse, de l'orientation et de l'inclinaison des panneaux</span>
            </div>
            <br/>  <strong>{{ (pvPower * 1000).toFixed() }} Wc</strong>
          </div>
          <div class="dataItem ">
                Recommandation nombre de panneaux<div class="tooltip">
                  <i class="fa fa-question"></i>
                  <span class="tooltiptext">Estimation sunethic pour un objectif de 50% d'autoconsommation en tenant compte de votre adresse, de l'orientation et de l'inclinaison des panneaux</span>
                </div>
                <br/>  <strong>{{pvSize}}</strong>
          </div>
        </div>
      </div>
    </div>
    <button id="" class="btn btn-simulateur" style="  border-radius: 30px !important;"  type="button" @click="goBack" name="button">MODIFIER MON DEVIS</button>
  </div>


</div>
  <div v-if="dataloading == true" class="loader" style="position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      background: #000000C0;
      z-index: 60000;
      color: #FFF;
      text-align: center;
      font-size: 24px;">
    <div style="text-align:center;display:block;margin:auto"> Votre évaluation est en cours. <br /> Merci de patienter quelques instants. </div>
  </div>

</template>

<script>
//import { LMap, LTileLayer,LMarker } from 'vue3-leaflet';
// import L from 'leaflet';
//import VueNumberInput from '@chenfengyuan/vue-number-input';
//  import Toggle from '@vueform/toggle'
import _ from 'lodash';
import axios from 'axios';


export default {
  name: 'EvaluateurDevis',
  components: {
  // LMap,
  // LTileLayer,
  // LMarker,
  // VueNumberInput,
  },
  data () {
    return {
      address: "",
      addressesShow: false,
      estimationDone:false,
      commercial_exploitation: false,
      pvSize: 0,
      pvPower:0,
      dataloading:false,
      monthlyBill : 100,
      typeCompteur: "mono",
      chauffageElect: true,
      orientation_panneaux: "SUD",
      inclinaison_panneaux: "standard",
      lieuPose:"toit_incline",
typeToit:"tuiles",
nb_etages:0,
nb_onduleur : 1,
nb_panneaux: 6,
puissance_panneau: 400,
marque_panneaux:"",
modelePanneau:"",
typeOnduleur:"micro",
marque_onduleur:"",
modele_onduleur: "",
gestionnaireEnergie: true,
marqueGestionnaire:"",
Batterie : false,
coffret: true,
coffrets_protection: null,
capaciteBatterie :"",
qualipvrge : true,
demarche_administrative : true,
tva : 20,
total_ttc : 5000,
consuel: true,
modeleGestionnaire:"",
listPanneaux:[],
listCoffrets:[],
listGestionnaires:[],
listOnduleurs:[],
listBatteries: [],
user_email :"",
user_telephone:"",
user_nom :"",
user_prenom :"",
estimation: {
  prix_achat_materiel :null,
  main_oeuvre : null,
  pays_panneaux : "",
  gamme_panneaux: "",
  tva : null,
  marge_brute: 0,
  bon_prix : null,
  note: "",
  conseil: "",
  code_note: ""
},
addresses: [],
errors: [],
    }
  },
  methods:{
    goBack(){
      this.estimationDone = false;
      window.scrollTo(0,0);
    },
    hideAddress(){
      this.addressesShow = false;
    },
    inputValid(){
      var error = false;
      var errorMsg = [];

      if(!this.address){
        error = true;
        errorMsg.push("Merci de renseigner votre adresse");
      }
      if(!this.orientation_panneaux){
        error = true;
        errorMsg.push("Merci de vérifier les informations à propos de l'orientation de vos panneaux solaires");
      }
      if(!this.inclinaison_panneaux){
        error = true;
        errorMsg.push("Merci de vérifier les informations à propos de l'inclinaison de vos panneaux solaires");
      }
      if(!this.marque_panneaux || !this.modelePanneau){
        error = true;
        errorMsg.push("Merci de vérifier les informations à propos de vos panneaux solaires");
      }
      if(!this.marque_onduleur || !this.modele_onduleur){
        error = true;
        errorMsg.push("Merci de vérifier les informations à propos des onduleurs");
      }
      if(!this.lieuPose){
        error = true;
        errorMsg.push("Merci de renseigner le lieu de pose");
      }
      else{
        if(this.lieuPose == "toit_incline" && !this.typeToit){
          error = true;
          errorMsg.push("Merci de renseigner votre type de toiture");
        }
        if(this.lieuPose == "toit_incline" || this.lieuPose == "toit_plat" ){
          if(this.nb_etages != 0 && this.nb_etages != 1 && this.nb_etages != 2 && this.nb_etages != 3){
            error = true;
            errorMsg.push("Merci de renseigner l'étage d'installation des panneaux solaires.");
          }
        }
      }
      if(this.gestionnaireEnergie){
        if(!this.marqueGestionnaire || !this.modeleGestionnaire){
          error = true;
          errorMsg.push("Merci de vérifier les informations à propos du gestionnaire d'énergie");
        }
      }
      if(this.Batterie){
        if(!this.capaciteBatterie){
          error = true;
          errorMsg.push("Merci de renseigner la capacité de la batterie de stockage");
        }
      }

      if(this.coffret){
        if(!this.coffrets_protection){
          error = true;
          errorMsg.push("Merci de vérifier les informations à propos du coffret de protection");
        }
      }

      if(!this.nb_panneaux){
        error = true;
          errorMsg.push("Merci de renseigner le nombre de panneaux");
      }
      if(!this.puissance_panneau){
        error = true;
        errorMsg.push("Merci de vérifier la puissance des panneaux");
      }
      if(!this.total_ttc){
        error = true;
        errorMsg.push("Merci de vérifier le total TTC de votre devis");
      }
      if(!this.user_email){
        error = true;
        errorMsg.push("Merci de renseigner une adresse email");
      }
      if(!this.user_telephone){
        error = true;
        errorMsg.push("Merci de renseigner un numéro de téléphone");
      }
      else{
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if( !emailPattern.test(this.user_email)){
          error = true;
          errorMsg.push("Merci de renseigner une adresse email valide");
        }
      }

      if(!this.user_nom){
        error = true;
        errorMsg.push("Merci de renseigner votre nom");
      }
      if(!this.user_prenom){
        error = true;
        errorMsg.push("Merci de renseigner votre prénom");
      }
      if(!this.commercial_exploitation){
        error = true;
        errorMsg.push("Merci d'accepter les conditions");
      }
      this.errors = errorMsg;
      return !error;
    },
    runEval(){
      this.errors = [];
      if(this.inputValid() == true){
      this.dataloading = true;
      window.scrollTo(0,0);
      var panneau = {
        marque : this.marque_panneaux,
        nombre : this.nb_panneaux,
        puissance : this.puissance_panneau,
        modele : this.modelePanneau
      };
      var onduleur = {
        marque: this.marque_onduleur,
        modele : this.modele_onduleur,
        nombre : this.nb_onduleur,
      };
      var gestionnaire = (!this.gestionnaireEnergie) ? null : {
        marque : this.marqueGestionnaire,
        modele : this.modeleGestionnaire
      };
      var installation = {
          lieu : this.lieuPose,
          type : (this.lieuPose == "toit_incline") ? this.typeToit : null,
          etage : (this.lieuPose == "toit_incline" || this.lieuPose == "toit_plat") ? this.nb_etages : null,
      };
      var batterie = (this.Batterie) ? this.capaciteBatterie : null;
      var coffret = (this.coffret) ? this.coffrets_protection : null;
      var autres_ifno = {
        qualipv : this.qualipvrge,
        demarches : this.demarche_administrative,
        tva: this.tva,
        phase : this.typeCompteur,
        consuel: this.consuel,
        user_email: this.user_email,
        user_telephone:this.user_telephone,
        user_nom :this.user_nom,
        user_prenom:this.user_prenom
      }
      var toPost = {
        "panneaux": panneau,
        "onduleur": onduleur,
        "gestionnaire" : gestionnaire,
        "installation" : installation,
        "batterie" : batterie,
        "coffret" : coffret,
        "autres" : autres_ifno,
        "total" : this.total_ttc
      }
      axios.post('/wp-json/evaluateur/v1/getEvaluation',toPost,{
            headers: {
                'Content-Type': 'application/json',
            }
        }).then( (r) => {
        var yearlyBill = this.monthlyBill * 12;
        var yearlyConsumption = (yearlyBill - 150) / 0.228;
        this.pvSize = Math.round((yearlyConsumption * 0.5 ) / 450); //OK 17/11
        if(this.pvSize > 8 && this.pvSize % 2 != 0)this.pvSize = this.pvSize + 1;
        this.pvSize = Math.min(this.pvSize,26);
        this.pvPower =  Math.floor(this.pvSize * 400) * 0.001;

        this.estimationDone = true;
        this.estimation.prix_achat_materiel = r.data.estimation_prix_achat;
        this.estimation.main_oeuvre = r.data.estimation_main_oeuvre;
        this.estimation.pays_panneaux = r.data.lieu_fab_panneau;
        this.estimation.gamme_panneaux = r.data.gamme_panneaux;
        this.estimation.tva = r.data.taux_tva;
        this.estimation.marge_brute = r.data.marge_brute;
        this.estimation.bon_prix = r.data.estimation_bon_prix;
        this.estimation.note = r.data.note;
        this.estimation.code_note = r.data.code_note;
        this.estimation.conseil = r.data.conseil;
        window.scrollTo(0,0);
        this.dataloading = false;
      });

      // setTimeout(() => {
      //
      // },3000);
    }
  },
  async searchAddresses() {
  if (this.address.length < 3) {
    this.addresses = [];
    return;
  }
  this.addressesShow = true;
  try {
    const response = await axios.get("https://api-adresse.data.gouv.fr/search", {
      params: {
        q: this.address,
        limit: 5,
      }
    });
    this.addresses = response.data.features.map((feature) => ({
      id: feature.properties.id,
      label: feature.properties.label
    }));
  } catch (error) {
    console.error("Erreur lors de la recherche d'adresses", error);
  }
},
selectAddress(address) {
  // Traitez l'adresse sélectionnée selon vos besoins
  this.address = address.label;
  this.addressesShow = false;
}
  },
  computed: {
  filteredPanneauxList() {
    return this.listPanneaux.filter(item => {
      return item.marque.toLowerCase().includes(this.marque_panneaux.toLowerCase())
    })
  },
  listMarquePanneaux(){
    return [...new Set(this.listPanneaux.map(item => item.marque))].sort(); // [ 'A', 'B']
  },
  filteredGestionnairesList() {
    return this.listGestionnaires.filter(item => {
      return item.marque.toLowerCase().includes(this.marqueGestionnaire.toLowerCase())
    })
  },
  listMarqueGestionnaire(){
    return [...new Set(this.listGestionnaires.map(item => item.marque))].sort(); // [ 'A', 'B']
  },
  filteredOnduleursList() {
    var temp = this.listOnduleurs.filter(item => {
      return item.type.toLowerCase().includes(this.typeOnduleur.toLowerCase())
    });
    return temp.filter(item => {
      return item.marque.toLowerCase().includes(this.marque_onduleur.toLowerCase())
    })
  },
  listMarqueOnduleurs(){
    var ond =  this.listOnduleurs.filter(item => {
      return item.type.toLowerCase().includes(this.typeOnduleur.toLowerCase())
    })
    return [...new Set(ond.map(item => item.marque))].sort(); // [ 'A', 'B']
  },

  filteredCoffretsList() {
    if(this.typeCompteur){
      return this.listCoffrets.filter(item => {
        return item.phase.toLowerCase().includes(this.typeCompteur.toLowerCase())
      })
    }
    else{
      return this.listCoffrets
    }
  },


},
watch: {
    monthlyBill: _.debounce(function(newmonthlyBill) {
      if(newmonthlyBill > 350)this.monthlyBill = 350;
      if(newmonthlyBill < 20)this.monthlyBill = 20;
    },1000),
    nb_panneaux: _.debounce(function(new_nb_panneaux) {
      if(new_nb_panneaux > 30)this.nb_panneaux = 30;
        if(new_nb_panneaux < 2)this.nb_panneaux = 2;
    },1000),
    nb_onduleur: _.debounce(function(nb_onduleur) {
      if(nb_onduleur > 30)this.nb_onduleur = 30;
        if(nb_onduleur < 1)this.nb_onduleur = 1;
    },1000),
    puissance_panneau: _.debounce(function(new_puissance_panneau) {
      if(new_puissance_panneau > 550)this.puissance_panneau = 550;
      if(new_puissance_panneau < 300)this.puissance_panneau = 300
    },1000),
    total_ttc: _.debounce(function(newttc) {
      if(newttc > 30000)this.total_ttc = 30000;
      if(newttc < 3000)this.total_ttc = 3000
    },1000),
},
  mounted(){
      axios.get('/wp-json/evaluateur/v1/getPanneaux').then( (r) => {
        console.log(r);
        this.listPanneaux = r.data;
      });
      axios.get('/wp-json/evaluateur/v1/getOnduleurs').then( (r) => {
        console.log(r);
        this.listOnduleurs = r.data;
      });
      axios.get('/wp-json/evaluateur/v1/getGestionnaires').then( (r) => {
        console.log(r);
        this.listGestionnaires = r.data;
      });
      axios.get('/wp-json/evaluateur/v1/getCoffrets').then( (r) => {
        console.log(r);
        this.listCoffrets = r.data;
      });
      axios.get('/wp-json/evaluateur/v1/getBatteries').then( (r) => {
        console.log(r);
        this.listBatteries = r.data;
      });
  },
}
</script>
<style media="screen">

  /****************************************************************************/
  /****************************************************************************/
  /***                     SELECTEUR MONTANT FACTURE                        ***/
  /****************************************************************************/
  /****************************************************************************/
  #EvaluateurDevis .wrapper-range{
    height: 80px;
    background: #fff;
    border-radius: 10px;
    padding: 60px 40px 20px 40px;
  }

  #EvaluateurDevis .field{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
    flex-wrap:wrap;
    width:100%;
    margin:0;
  }
  #EvaluateurDevis .field .value{
    font-size: 18px;
    color: #008a83;
    font-weight: 600;
    width: 90px;
    display:block;
  }
  #EvaluateurDevis .field .value.left{
    text-align: left;
  }
#EvaluateurDevis   .field .value.right{
    text-align: right;
  }
  #EvaluateurDevis .field input {
    flex: 1 1 auto;
  }

  #EvaluateurDevis .sliderValue{
    position: relative;
    width: 100%;
        top:-50px;
  }
  #EvaluateurDevis .sliderValue span{
    position: absolute;
    width: 100%;
    font-weight: 500;
    color: #008a83;
    font-size:28px;
    text-align:center;
  }


  #EvaluateurDevis input[type="range"]{
    -webkit-appearance: none;
    width: calc(100% - 200px);
    height: 8px;
    outline: none !important;
    appearance:none;
    border:none;
    margin:0;
    border-radius:30px;
  }
  #EvaluateurDevis input[type="range"]::-moz-focus-outer {
      border: 0;
  }
  #EvaluateurDevis input[type="range"]:hover {
    outline:none;
  }


  #EvaluateurDevis input[type=range]::-webkit-slider-runnable-track {
    background-color: #ccc;
    border-radius:30px;
    border:none;
      height: 100%;
  }

  #EvaluateurDevis input[type=range]::-webkit-slider-thumb {
      -webkit-appearance: none;
      border: none;
      height: 24px;
      width: 24px;
      background: #008a83;
      cursor: pointer;
      border-radius:50%;
      border:4px solid #008a83;
      margin-top: -8px;
  }

  /* Moz */

  #EvaluateurDevis input[type="range"]::-moz-range-thumb {
    width: 18px;
    height: 18px;
    background: #008a83;
    cursor: pointer;
    border-radius:50%;
    border:4px solid #008a83;
    outline:none;
  }
#EvaluateurDevis   input[type="range"]::-moz-range-progress {
    background-color: #ccc;
      height: 100%;
    border-radius:30px;
    border:none;
  }
#EvaluateurDevis   input[type="range"]::-moz-range-track {
    background-color: #ccc;
    border-radius:30px;
    border:none;
      height: 100%;
  }

  /* IE*/

#EvaluateurDevis   input[type="range"]::-ms-fill-lower {
    background-color: #ccc;
      height: 100%;
    border-radius:30px;
    border:none;
  }
#EvaluateurDevis   input[type="range"]::-ms-fill-upper {
    background-color: #ccc;
    border-radius:30px;
    border:none;
      height: 100%;
  }




#EvaluateurDevis  button:not(.vue-number-input__button):not(.btn-close){
  background : #ffcf00;
  border-radius:15px;
  color:#000;
  text-transform: uppercase;
  display:inline-block;
  border:2px solid #FFCF00;
  margin-top: 30px;
  margin-left: 10px;
  margin-right:10px;
}
#EvaluateurDevis button:not(.vue-number-input__button):not(.btn-close):hover{
    background : #FFF;
}

#EvaluateurDevis .entryPointSunEthic button:not(.vue-number-input__button):not(.btn-close),
#EvaluateurDevis .calculatedValues button:not(.vue-number-input__button):not(.btn-close){
  display:block;
  margin-left:auto;
  margin-right: auto;
}
#EvaluateurDevis .sectionTitle{
  font-size:30px;text-align:center;margin-bottom: 50px;
}

#EvaluateurDevis .sectionContainer{
  margin-top:75px;
  margin-bottom:75px;
  box-shadow: 0 0 7px 1px rgba(0,0,0,.07);
-webkit-box-shadow: 0 0 7px 1px rgba(0,0,0,.07);
-moz-box-shadow: 0 0 7px 1px rgba(0,0,0,.07);
padding: 20px;
border-radius: 20px;
}
#EvaluateurDevis .sectionContainer:first-of-type{
  margin-top:0px;
}


#EvaluateurDevis #errorEstimation{
  width:100%;
  padding:20px;
  margin-top:50px;
  margin-bottom: 50px;
  background:#e67878;
  color:#fff;
}
#EvaluateurDevis #errorSendEtudeByMail{
  width:100%;
  padding:20px;
  margin-top:50px;
  margin-bottom: 50px;
  background:#e67878;
  color:#fff;
}
#EvaluateurDevis #etudeSend{
  width:100%;
  padding:20px;
  margin-top:50px;
  margin-bottom: 50px;
  background:#008a83;
  color:#fff;
}

#EvaluateurDevis .resultDataContainer{

  padding: 20px;

}

:root {
  --toggle-width: 4rem;
  --toggle-height: 1.2rem;
  --toggle-font-size: 0.8rem;
  --toggle-bg-on: #008a83;
  --toggle-border-on: #008a83;

}

#EvaluateurDevis .tooltip {
  position: relative;
  display: inline;
  border-radius: 50%;
  border: 1px solid #ccc;
    padding: 2px 6px;
  color: #CCC;
  font-size: 15px;
}

#EvaluateurDevis .tooltip .fa{
      font-size: 18px;
}
/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 400px;
  background-color: #FFF;
  color: #000;
  text-align: justify;
  padding: 10px;
  border-radius: 6px;
  position: absolute;
  z-index: 50;
  -webkit-box-shadow: 0px 0px 11px 0px rgba(0,0,0,0.07);
  box-shadow: 0px 0px 11px 0px rgba(0,0,0,0.07);
  top: calc(100% + 10px);
  left: calc(0% - 200px);
  line-height: 1.2rem;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}

:root {
  --background-gradient: linear-gradient(178deg, #ffff33 10%, #3333ff);
  --gray: #34495e;
  --darkgray: #2c3e50;
}
#EvaluateurDevis .select select {
  /* Reset Select */
  appearance: none;
  outline: 10px #008a83;
  border: 0;
  box-shadow: none;
  /* Personalize */
  flex: 1;
  padding: 0 1em;
  color: #008a83;
  background-color: #FFF;
  background-image: none;
  cursor: pointer;
  border:1px solid #008a83;
}
/* Remove IE arrow */
#EvaluateurDevis .select select::-ms-expand {
  display: none;
}
/* Custom Select wrapper */
#EvaluateurDevis .select {
  position: relative;
  display: flex;
  width: 20em;
  height: 3em;
  border-radius: .25em;
  overflow: hidden;
  max-width: 100%;
width: 100%;
}
/* Arrow */
#EvaluateurDevis .select::after {
  content: '\25BC';
  position: absolute;
  top: 0;
  right: 0;
  padding: 1em;
  background-color: #008a83;
  transition: .25s all ease;
  pointer-events: none;
  color:#FFF;
  font-size: 17px !important;
line-height: 17px !important;
}
/* Transition */
#EvaluateurDevis .select:hover::after {
  color: #fff;
}
.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 50px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}

#EvaluateurDevis .hideInput{
  width: 130px !important;
border: 1px solid #EEE;
padding-left: 5px;
padding-right: 5px;
color: #008a83;
font-size: 28px;
text-align: center;
padding: 0;
margin-right: 5px !important;
}

#EvaluateurDevis .inclinaison_wrapper{
  max-width: 100%;
  background: #FFF;
  border-radius: 10px;
  display:flex;
   flex-wrap: wrap;
}
#EvaluateurDevis .form__answer {
box-sizing: border-box;
font-size: 22px;
text-align: center;
align-self: center;
/* flex:1; */
margin-left: 15px;
margin-right: 15px;
align-self: stretch;
width: calc(100% / 4 - 30px);
margin-top:10px;
padding-bottom: 0 !important;
margin-bottom: 20px !important;
}
#EvaluateurDevis .inclinaison_wrapper label {
padding: 30px 10px 30px 10px;
box-sizing: border-box;
display: block;
height: 100%;
width: 100%;
cursor: pointer;
border: 2px solid transparent;
border-radius: 30px;
font-size:18px;
box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);
-webkit-box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);
-moz-box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);
align-content: center;
align-items: center;
align-self: center;
display: flex;
flex-direction: column;
justify-content: center;
}
@media screen and (max-width:990px){
  #EvaluateurDevis .form__answer {
  box-sizing: border-box;
  font-size: 22px;
  text-align: center;
  align-self: center;
  /* flex:1; */
  margin-left: 15px;
  margin-right: 15px;
  align-self: stretch;
  width: calc(100% / 2 - 30px);
  }
  #EvaluateurDevis .inclinaison_wrapper label {
  padding: 20px 10px 20px 10px;
  box-sizing: border-box;
  display: block;
  height: 100%;
  width: 100%;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 30px;
  font-size:16px;
  box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);
  -webkit-box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);
  -moz-box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.07);
  }
}


/*
#EvaluateurDevis .inclinaison_wrapper .text_black{
color: #000;
} */


#EvaluateurDevis .inclinaison_wrapper input[type=radio] {
opacity: 0;
width: 0;
height: 0;
display:none;
}

#EvaluateurDevis .inclinaison_wrapper input[type=radio]:active ~ label {
opacity: 1;
}

#EvaluateurDevis .inclinaison_wrapper input[type=radio]:checked ~ label {
opacity: 1;
color:#FFF !important;
background: #008a83;
}
#EvaluateurDevis .inclinaison_wrapper input[type=radio]:checked ~ label span{
color: #FFF !important;

}


#EvaluateurDevis .h3like{
  font-family: "Righteous";
font-weight: 400;
color: inherit;
margin-bottom: 20px;
font-size: 18px;
}

#EvaluateurDevis .champ{
  margin-bottom: 50px;
}
#EvaluateurDevis .inclinaison_wrapper .text_green{
  color:#008a83;
  font-size:15px;
}


#EvaluateurDevis .recommandations {
  display: flex;
  padding: 40px;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  background-color: #f1f4f8;
  border-radius: 25px 25px 0px 0px;
}
#EvaluateurDevis .recommandations .leftContainer{
  width: 60%;
}

#EvaluateurDevis .recommandations .rightContainer{
  width: 40%;
}

@media screen and (max-width: 768px){
  #EvaluateurDevis .recommandations .leftContainer,
  #EvaluateurDevis .recommandations .rightContainer{
    width:100%;
    text-align:center;
}
}
#EvaluateurDevis .panelsHeader {
  color: #008a83;
  display: flex;
  text-align: center;
  align-items: center;
  font-weight: bold;
  flex-direction: column;
  justify-content: center;
}
#EvaluateurDevis .panels-heading{
  font-size:20px;
}
#EvaluateurDevis .panelsHeader > .pvSize{
  font-size: 30px;
}


.avisPastille{
  background: #008A83;
justify-content: center;
align-items: center;
border-radius: 100%;
text-align: center;
margin: 5px 20px;
font-size: 20px;
text-transform: uppercase;
font-weight: 700;
padding: 15px;
display: flex;
height: 180px;
width: 180px;
color: #fff;
margin: auto;
}


#EvaluateurDevis .resultDataContainer{
  border: 3px solid #f1f4f8;
  padding: 20px;

}
#EvaluateurDevis .dataInner{
  display: flex;
flex-wrap: wrap;
}

#EvaluateurDevis .dataItem{
  width: calc(50% - 20px);
  margin: 10px;
  padding-right: 20px;
}

#EvaluateurDevis .oneLine .dataItem{
  width: calc(25% - 20px);
  margin: 10px;
}

#EvaluateurDevis .resultEcoDatas,
#EvaluateurDevis .resultProductDatas{
  margin-top: 20px;
  margin-bottom:20px;
padding-top: 20px;
}

#EvaluateurDevis .text-justify{
  text-align: justify
}
#EvaluateurDevis .resultProductDatas .dataItem strong,
#EvaluateurDevis .resultEcoDatas .dataItem strong{
  font-size:1.5em;
}

#EvaluateurDevis .resultProductDatas .dataItem strong,
#EvaluateurDevis .resultEcoDatas .dataItem strong{
  font-size:1.5em;
}

#EvaluateurDevis .dataItem.dataImportant strong{
  color: #008a83;
}

#EvaluateurDevis .dataItem{
  width: calc(50% - 20px);
  margin: 10px;
}




@media screen and (max-width: 768px){
  #EvaluateurDevis .recoDesc{
    max-width:100%;
  }
  #EvaluateurDevis .dataItem,
  #EvaluateurDevis .oneLine .dataItem{
    width: calc(100% - 20px);
    margin: 10px;
  }
  #EvaluateurDevis .rightContainer{
    margin-top:20px;
  }
}
@media only screen and (min-width : 768px) and (max-width : 1024px) {
  #EvaluateurDevis .oneLine .dataItem{
    width: calc(50% - 20px);
    margin: 10px;
  }
}
#EvaluateurDevis .tooltip {
  position: relative;
  display: inline;
  border-radius: 50%;
  border: 1px solid #ccc;
  padding: 5px 10px;
  color: #CCC;
  font-size: 15px;
  font-family: "Poppins";
}

/* Tooltip text */
#EvaluateurDevis .tooltip .tooltiptext {
  visibility: hidden;
  width: 400px;
  background-color: #FFF;
  color: #000;
  text-align: justify;
  padding: 10px;
  border-radius: 6px;
  position: absolute;
  z-index: 50;
  -webkit-box-shadow: 0px 0px 11px 0px rgba(0,0,0,0.07);
  box-shadow: 0px 0px 11px 0px rgba(0,0,0,0.07);
  top: calc(100% + 10px);
  left: calc(0% - 200px);
  line-height: 1.2rem;
}

/* Show the tooltip text when you mouse over the tooltip container */
#EvaluateurDevis .tooltip:hover .tooltiptext {
  visibility: visible;
}
#EvaluateurDevis .dataItem.fullWidth{
  width:100% !important;
}

#EvaluateurDevis .interessant{
  background:#008A83;
}
#EvaluateurDevis .acceptable{
  background:#b2c208;
}
.prix_un_peu_eleve{
  background:#c2ae08;
}
.prix_eleve{
  background:#dd9204;
}
.prix_tres_eleve{
  background:#DD6004;
}
.prix_beaucoup_trop_eleve{
  background:#DD0404;
}

#EvaluateurDevis [data-content]{
  white-space: pre-line !important;
}

#EvaluateurDevis .alert{
  margin-top:20px;
  background:#F8D7DA;
  color:#721C24;
  padding:20px;
}

@media screen and (max-width:680px){
  #EvaluateurDevis .field .value{
    display:none;
  }
  #EvaluateurDevis .field input[type=range]{
    width:100%;
  }
  #EvaluateurDevis .sliderValue {
  position: relative;
  width: 100%;
  top: -65px;
}
#EvaluateurDevis .wrapper-range {
  height: 80px;
  background: #fff;
  border-radius: 10px;
  padding: 70px 40px 20px 40px;
}
}

.fa-question::before {
  content: "\3f"; }

  .fa {
  font-family: var(--fa-style-family, "Font Awesome 6 Free");
  font-weight: var(--fa-style, 900); }

.fa,
.fa-classic,
.fa-sharp,
.fas,
.fa-solid,
.far,
.fa-regular,
.fab,
.fa-brands {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto; }

  .redText{
    color:red !important;
  }

  .redText .notice{
    font-size: 14px;
line-height: 18px;
display: block;
  }

  #doEvaluation{
    font-size: 20px;
  }

  .pictoSection{
    width:150px !important;margin:auto;
  }

  .text-center{
    text-align:center;
    margin: auto;
    margin-bottom: auto;
  display: block;
  }

  .champ .h3like{
    display:block;
    text-align:center;
    margin-left: auto;
    margin-right: auto;
  }
  .champ .inclinaison_wrapper{
    justify-content: center;
  }

  .address-list {
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
  border-top: none;
  position: absolute;
  width: 100%;
  background: #FFF;
  z-index: 500;

}

.address-item {
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
  list-style: none;
  z-index:600;

}
.inputZone{
  position:relative;
}

.address-item:hover {
  background-color: #f5f5f5;
}

.btn-simulateur{
  display:inline-block;
  margin:auto;
}
</style>
